import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { API } from 'api';
import { ReportPhoto } from 'features/reports/report.types';
import { AxiosResponse } from 'axios';

const fetchReportsPhotos = (): Promise<AxiosResponse<ReportPhoto[]>> =>
  API.get<ReportPhoto[]>('reports/photos');

// Fetches all approved reports with photos across every incident.
export const useReportsPhotosQuery = (props?: {
  enabled?: boolean;
}): UseQueryResult<AxiosResponse<ReportPhoto[]> | undefined> => {
  const query = useQuery({
    queryKey: ['reports', 'photos'],
    queryFn: fetchReportsPhotos,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 6, // 6 minutes - must be bigger than staleTime
    enabled: props?.enabled ?? true,
  });

  return query;
};
